export default __webpack_public_path__ + "static/media/Basuti_Bolo_AHV_In_Moms_We_Trust.94f30215.jpg";